import { cn } from '@/lib/utils'

const LOGO_SRC = '/app-logo.png'

type BrandLogoProps = {
  className?: string
  alt?: string
}

export function BrandLogo({ className, alt = 'นายลัง ผู้ช่วยส่วนตัว บริการ' }: BrandLogoProps) {
  return (
    <img
      src={LOGO_SRC}
      alt={alt}
      draggable={false}
      className={cn('object-contain select-none', className)}
    />
  )
}
